import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtilService {
    constructor() {
    }

    currencyCode(currency : string) {
        switch (currency) {
            case 'PLN':
                return '985';
            case 'EUR':
                return '978';
            case 'USD':
                return '840';
            case 'GBP':
                return '826';
            default:
                return '';
        }
    }
}